import { h, Component } from 'preact';
import { withContext } from 'common/context';
import { isMobile } from 'mobile-device-detect';
import MultiZoomButtons from './MultiZoomButtons';
import { getValidSteps } from '../Zoom.utils';

class MultiZoom extends Component {
  state = {
    steps: 0
  };

  componentDidMount() {
    this.calcMultiZoomSteps();
  }

  calcMultiZoomSteps = async () => {
    // state.steps holds the number of zoom steps that will not cause
    // the original image to be stretched.
    // use it to prevent zoom levels that exceeds original image dimensions
    const { level, steps, context } = this.props;
    const logErrors = context.config.selectLogErrors();
    // Get original image info
    try {
      const assetInfo = await context.cloudinary.getAssetInfo(this.props?.asset?.publicId);

      if (assetInfo && assetInfo.input) {
        const assetWidth = assetInfo.input.width;

        // Calc maxAvailableZoom
        const validSteps = getValidSteps(level, steps, assetWidth);
        this.setState({ steps: validSteps });

        if (logErrors && steps > 0 && validSteps === 0) {
          console.warn(
            `Original asset size does not allow for extra zoom levels. [asset width: ${assetWidth}px]`
          );
        }
      }
    } catch (error) {
      if (logErrors) console.error(error);
    }
  };

  zoomIn = () => {
    const nextStep = this.props.currentStep + 1;
    if (this.props.currentStep == 0) {
      this.props.zoomIn();
    } else {
      this.props.setMultiZoom(nextStep);
    }
  };

  zoomOut = () => {
    const nextStep = this.props.currentStep - 1;
    if (nextStep === 0) {
      this.props.zoomOut();
    } else {
      this.props.setMultiZoom(nextStep);
    }
  };

  render(props, state) {
    // if stepLimit - limit to available zoom (lossless), otherwise allow up to props.steps.
    const zoomSteps = this.props.stepLimit ? state.steps : props.steps;
    const maxZoom = Math.pow(this.props.level, this.props.steps);

    const shouldRender = !isMobile && zoomSteps > 0 && maxZoom > 1;

    return shouldRender ? (
      <MultiZoomButtons
        {...props.context.config.selectNavigationButtonProps()}
        currentStep={props.currentStep}
        steps={zoomSteps}
        zoomIn={this.zoomIn}
        zoomOut={this.zoomOut}
      />
    ) : null;
  }
}

export default withContext(MultiZoom);
